import store from "@/store";
import { appendHTML } from "./HTMLService";
import mixpanel from 'mixpanel-browser';
 
// Set this to a unique identifier for the user performing the event.
//mixpanel.identify('USER_ID')


declare const ga;
declare const fbq;
declare const snaptr;
declare const ttq;

declare let window;

export async function startTiktokPixelWithId(tiktok_pixel_id: string) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }
  
  /*const html = `
    <script>
        ttq.load('` + tiktok_pixel_id + `');
        ttq.page();
    </script>
  `;

  appendHTML(html);*/

  ttq.load('` + tiktok_pixel_id + `');
  ttq.page();
}

export async function startGoogleTagWithId(google_tag_id: string) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  const html = `
    <script type='text/javascript' async src='https://www.googletagmanager.com/gtag/js?id=` + google_tag_id + `'></script>
    
    <script type='text/javascript'>
      window.dataLayer = window.dataLayer || [];
    
      function gtag(){dataLayer.push(arguments);}
    
      gtag('js', new Date());
    
      gtag('config', '` + google_tag_id + `');
    
    </script>
  `;

  appendHTML(html);
}

export async function startGoogleTagManagerWithId(google_tag_manager_id: string) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  const html = `
    
    <!-- Google Tag Manager -->
    <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','` + google_tag_manager_id + `');</script>
    <!-- End Google Tag Manager -->

    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=` + google_tag_manager_id + `"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->`;

    appendHTML(html);
}

export async function startSnapchatPixilWithId(snapchatPixilId: string) {
  //todo: global track 
  
  if(!store.state['store']) {
    console.log("no store while startSnapchatPixilWithId")
    return null; 
  }
/*
  const html = `
    <!-- Snap Pixel Code -->
    <script type='text/javascript'>
    
    snaptr('init',  '` + snapchatPixilId + `', {
      'user_email': '_INSERT_USER_EMAIL_'
    });

    snaptr('track', 'PAGE_VIEW');
    
    </script>
    <!-- End Snap Pixel Code -->`;

    appendHTML(html);*/

    snaptr('init',  snapchatPixilId, {
      'user_email': '_INSERT_USER_EMAIL_'
    });

    snaptr('track', 'PAGE_VIEW');
}

/**
 * start fb pixil tracking
 * @param facebook_pixil_id 
 */
export async function startFbPixilWithId(facebookPixilId: string) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  /*
  const html = `
    <!-- Facebook Pixel Code -->
    
     <script>
    !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        </script>

    <noscript>
            <img height='1' width='1' style='display:none'
        src='https://www.facebook.com/tr?id= ` + facebookPixilId + ` &ev=PageView&noscript=1'
        />
    </noscript>
    <!-- End Facebook Pixel Code -->`;
    
    appendHTML(html);*/

    fbq('init', facebookPixilId);
    fbq('track', 'PageView');
    fbq('track', 'ViewContent');
}
 
/**
 * Start Tracker
 * @param id 
 */
export async function startGoogleAnalytics(id: string) {
//todo: global track 
  
if(!store.state['store']) {
  return null; 
}

  if (typeof ga == "undefined")
    return false;

  try {

    ga('create', {
      storage: 'none',
      trackingId: id,
      //clientId: clientIdValue
    });
    ga('set', 'checkProtocolTask', null);
    ga('set', 'transportUrl', 'https://www.google-analytics.com/collect');
    /*ga((tracker: any) => {
       
        if (!value) {
          Storage.set({
            key: 'ga:clientId',
            value: JSON.stringify(tracker.get('clientId'))
          }).then();
        }
      })
    });*/
  } catch (error: any) {
    console.error(JSON.stringify(error.message));
  }
}

/**
 * Track Screen View
 * @param screenName 
 */
export async function trackView(screenName, itemName = null, itemPrice = null) {
  
  let params = {
    company_id: store.state['restaurant_uuid'],
    store_id : store.state['restaurant_uuid'],
    language : store.state['language']?.code,
    channel : "Store Web App",
    role : store.state['isLogin']? "Login User": "Guest"
  };

  mixpanel.track_pageview({"page": screenName, ...params});
  
  window.analytics.page(screenName, itemName);

  //todo: global track 

  if(!store.state['store']) {
    console.log("no store while trackView")
    return null; 
  }

  if (store.state['store'].google_analytics_id) {
    try {
      ga('set', 'page', screenName);
      ga('send', 'pageview');
    } catch (error) {
      //   console.error( JSON.stringify(error.message));
    }
  }

  if (store.state['store'].facebook_pixil_id) {
    try {
      fbq('track', 'ViewContent', {
        content_name: screenName,
        value: itemPrice,
        currency: store.state['currency']
      });
    } catch (error) {
      console.error( JSON.stringify(error.message));
    }
  } else {
    console.log("no facebook_pixil_id while trackView")
  }

  //VIEW_CONTENT
  if (store.state['store'].snapchat_pixil_id) {
    
    try {
      snaptr('track', "PAGE_VIEW", {
        content_name: screenName,
        value: itemPrice,
        currency: store.state['currency']
      });

      snaptr('track', 'VIEW_CONTENT', {
        content_name: screenName,
        value: itemPrice,
        currency: store.state['currency']
      });

    } catch (err) { 
      console.error(err);
    }
  }
}

/**
 * Track Screen View
 * @param screenName 
 */
export async function purchaseEventFacebookPixil(totalAmount) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  try {
    fbq('track', 'Purchase', { value: totalAmount, currency: store.state['currency'] });
  } catch (err) { 
    console.error(err);
  }
}

/**
 * Track Screen View
 * @param screenName 
 */
export async function initiateCheckoutEventFacebookPixil(totalAmount) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  try {
    fbq('track', 'InitiateCheckout',
      {
        value: totalAmount,
        currency: store.state['currency'] // or set to empty string
      });
  } catch (err) { 
    console.error(err);
  }
}

/**
 * purchaseEventSnapchatPixil
 * @param totalAmount 
 * @param currency 
 * @param orderUuid 
 */
export async function purchaseEventSnapchatPixil(totalAmount, currency) {
  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  try {
    snaptr('track', 'PURCHASE', { 'currency': currency, 'price': totalAmount });
  } catch (err) { 
    console.error(err);
  }
}

/**
 * initiateCheckoutEventSnapchatPixil
 * @param totalAmount 
 * @param currency 
 */
export async function initiateCheckoutEventSnapchatPixil(totalAmount, currency) {
  
  if(!store.state['store']) {
    return null; 
  }

  try {
    snaptr('track', 'START_CHECKOUT', { 'currency': currency, 'price': totalAmount });
  } catch (err) { 
    console.error(err);
  }
}

/**
 * addToCartEventFacebookPixel
 * @param totalAmount 
 * @param currency 
 * @param orderUuid 
 */
export async function addToCartEventFacebookPixel(itemUuid, itemName, itemPrice) {
  //todo: global track 
  
  if(!store.state['store']) {
    console.log("no store while addToCartEventFacebookPixel")
    return null; 
  }

  if (store.state['store'].facebook_pixil_id) {
    try {
      fbq('track', 'AddToCart', {
        content_ids: itemUuid,
        content_name: itemName,
        content_type: 'product',
        value: itemPrice,
        currency: store.state['currency']
      });
    } catch (err) { 
      console.error(err);
    }
  } else {
    console.log("no facebook_pixil_id while addToCartEventFacebookPixel")
  }
}

/**
 * Track Event
 * @param category 
 * @param action 
 * @param label 
 * @param value 
 */
export async function trackEvent(category, action, label?, value?, price?, itemUuid?) {
 
  const props = {
    'action': action,
    'label': label,
    'value': value, 
    price: price, 
    itemUuid: itemUuid,
    company_id: store.state['restaurant_uuid'],
    store_id : store.state['restaurant_uuid'],
    language : store.state['language']?.code,
    channel : "Store Web App",
    role : store.state['isLogin']? "Login User": "Guest"
  };

  if(window.analytics) {
    window.analytics.track(action, props);
  }

  mixpanel.track(action, props);

  //todo: global track 
  
  if(!store.state['store']) {
    return null; 
  }

  if (store.state['store'].google_analytics_id) {
    try {
      ga('send', 'event', {
        eventCategory: category,
        eventLabel: label,
        eventAction: action,
        eventValue: value
      });
    } catch (error) {
      console.error(JSON.stringify(error.message));
    }
  }

  if (action == 'add-to-cart' && store.state['store'].facebook_pixil_id) {
    addToCartEventFacebookPixel(itemUuid, value, price);
  }

  /*if (store.state['store'].facebook_pixil_id) {
    fbq('track', action, props);
  }*/

  if (action == 'add-to-cart' && store.state['store'].snapchat_pixil_id) {
    try {
      snaptr('track', "ADD_CART", {
        'currency': store.state['currency'],
        'price': price
      });
    } catch (err) { 
      console.error(err);
    }
  }
}